import { loggedIn } from '../../../../routes/conditional';
import paths from '../../../../routes/paths';
import {
  setCalendarDisplayDate,
  setSelectedOrderDate,
  clearErrorMessage,
} from '../../../../redux/modules/scheduling';
import { getPendingOrdersFromHomeReorder, getSchedulingDisplayDate } from '../../../../redux/modules/root-reducer';

export const page = {
  path: paths.createOrder.scheduling,
  isAllowed: [loggedIn],
  action: ({ state }) => {
    if (getSchedulingDisplayDate(state) === null) {
      const dt = new Date();
      return setCalendarDisplayDate(new Date(dt.setDate(dt.getDate() + 1)));
    }
    return null;
  },
};

export const setPrevCalendarMonth = {
  actionPath: '/actions/scheduling/subtract-calendar-month',
  action: ({ state }) => {
    const date = new Date(getSchedulingDisplayDate(state));
    date.setUTCMonth(date.getUTCMonth() - 1);
    return setCalendarDisplayDate(date);
  },
};

export const setNextCalendarMonth = {
  actionPath: '/actions/scheduling/add-calendar-month',
  action: ({ state }) => {
    const date = new Date(getSchedulingDisplayDate(state));
    date.setUTCMonth(date.getUTCMonth() + 1);
    return setCalendarDisplayDate(date);
  },
};

export const setOrderDate = {
  actionPath: '/actions/scheduling/set-order-date',
  action: ({ body, state }) => setSelectedOrderDate(body.date, getPendingOrdersFromHomeReorder(state)),
};

export const clearError = {
  actionPath: '/actions/scheduling/clear-error',
  action: () => clearErrorMessage(),
};
